import { inject, InjectionToken, Signal } from '@angular/core';
import { NxViewportService, NxBreakpoints } from '@allianz/ng-aquila/utils';
import { toSignal } from '@angular/core/rxjs-interop';

export const IS_DESKTOP_WIDTH = new InjectionToken<Signal<boolean>>('IS_DESKTOP_WIDTH', {
  factory: () => toSignal(inject(NxViewportService).min(NxBreakpoints.BREAKPOINT_MEDIUM)),
});
